/* eslint-disable max-len */

import React, { Component } from 'react';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Filters from '../../shared/fixed-filters/main';

import wrapMain from '../wrap-main';

import { selectors, actions } from './';

import './index.less';

class Table extends Component {
	constructor(props) {
		super(props);

		this.state = {
			levels: [],
			sorting: {}
		};
	}

	render() {
		const { intl, filters, table, ...props } = this.props;

		return (
			<div className='marketing-funnel-affiliate-stat'>
				<div className='marketing-funnel-actions'>
					<div className='marketing-funnel-filters clearfix'>
						<Filters intl={intl} {...props} {...filters} filters={filters}/>
					</div>
					<button
						className='ui-btn ui-btn-primary'
						onClick={props.apply}
					>
						{intl('Apply')}
					</button>
					<button
						className='ui-btn ui-btn-secondary ui-icon-clear'
						onClick={props.clear}
					/>
				</div>

				<div className='table-container'>
					<table className="simple-table">
						<thead className="simple-table__head">
							<tr>
								{Object.keys(table.columns)
									.map((header, index) =>
										<th key={index} className="marketing-funnel-affiliate-stat-cell">
											<span> {intl(table.columns[header].title)} </span>
										</th>
									)}
							</tr>
						</thead>
						<tbody className="simple-table__body">
							{
								table.rows.map((row, index) =>
									<tr key={index}>
										<td className="marketing-funnel-affiliate-stat-cell">{row.id}</td>
										<td className="marketing-funnel-affiliate-stat-cell">{row.referer}</td>
										<td className="marketing-funnel-affiliate-stat-cell">{row.tags}</td>
										<td className="marketing-funnel-affiliate-stat-cell">
											{row.lead_source_names}
										</td>
										<td className="marketing-funnel-affiliate-stat-cell">{row.country_name}</td>
										<td className="marketing-funnel-affiliate-stat-cell">{row.registered_at}</td>
										<td className="marketing-funnel-affiliate-stat-cell">{row.start_traffic_date}</td>
										<td className="marketing-funnel-affiliate-stat-cell">
											{row.total_leads} / {row.approved_leads}
										</td>
									</tr>
								)
							}
						</tbody>
					</table>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		isLoading: selectors.select(state, 'isLoading'),
		isError: selectors.select(state, 'isError'),
		data: selectors.select(state, 'data'),
		table: selectors.getTable(state),
		// -----------------------------------------
		filters: selectors.getFilters(state),
		calendar: selectors.getCalendar(state)
	};
}

export default connect(mapStateToProps, dispatch => bindActionCreators(actions, dispatch))(wrapMain(Table));



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/marketing-funnel/affiliate-stat/main.js